export default "__VITE_ASSET__JG3OFpUh__"